import {
  createTheme as createMuiTheme,
  MuiThemeProvider,
} from '@material-ui/core/styles';
import { theme as rawTheme } from '../theme';
import { ThemeProvider } from 'styled-components';
import useSellerTheme from '@seller-hermes/hooks/useSellerTheme';
import {
  ThemeToggleContext,
  useThemeTogglerRoot,
} from '@seller-hermes/hooks/useThemeToggler';
import Provider from '@seller-hermes/app/provider';
import i18n from '@seller-hermes/i18n/config';
import { useAbbiamoUiConfig } from './config';
import { ShadcnThemeProvider } from '@seller-hermes/features/ui-v2/ThemeProvider';

import * as React from 'react';

const AbbiamoUiProvider = Provider as any;

const ThemeDeps: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const themeManagerRoot = useThemeTogglerRoot();

  const sellerTheme = useSellerTheme(themeManagerRoot.themeType);

  const theme = React.useMemo(
    () => ({
      ...rawTheme,
      sellerTheme,
      type: themeManagerRoot.themeType as any,
    }),
    [themeManagerRoot, sellerTheme],
  );

  const muiTheme = React.useMemo(
    () =>
      createMuiTheme({
        props: {
          MuiButtonBase: {
            disableRipple: true,
          },
        },
        palette: {
          type: themeManagerRoot.themeType,
          primary: {
            main: sellerTheme.primary.value,
            contrastText: sellerTheme.primary.safeColorInsideContainer,
          },
          secondary: {
            main: sellerTheme.primary.safeColorAgainstBg,
            contrastText: sellerTheme.primary.safeColorInsideContainer,
          },
          text: {
            primary:
              theme.type === 'light'
                ? theme.colors.black[1000]
                : theme.colors.white[1000],
          },
        },
        typography: {
          fontSize: 25,
        },
      }),
    [themeManagerRoot, theme, sellerTheme],
  );
  const abbiamoUiConfig = useAbbiamoUiConfig();

  // React.useEffect(() => {
  //   const primaryColor = hexToHsl(sellerTheme.primary.value);
  //   document.body.style.setProperty(
  //     '--primary',
  //     `${primaryColor.h} ${primaryColor.s}% ${primaryColor.l}%`
  //   );

  //   const primaryColorForeground = hexToHsl(
  //     sellerTheme.primary.safeColorInsideContainer
  //   );
  //   document.body.style.setProperty(
  //     '--primary-foreground',
  //     `${primaryColorForeground.h} ${primaryColorForeground.s}% ${primaryColorForeground.l}%`
  //   );
  // }, [sellerTheme]);

  return (
    <AbbiamoUiProvider
      config={abbiamoUiConfig}
      i18n={i18n}
      sellerTheme={sellerTheme}
      themeType={themeManagerRoot.themeType}
    >
      <ThemeToggleContext.Provider value={themeManagerRoot}>
        <MuiThemeProvider theme={muiTheme}>
          <ThemeProvider theme={theme as any}>
            <ShadcnThemeProvider theme={theme.type}>
              {children}
            </ShadcnThemeProvider>
          </ThemeProvider>
        </MuiThemeProvider>
      </ThemeToggleContext.Provider>
    </AbbiamoUiProvider>
  );
};

export default ThemeDeps;
